// Données fictives pour le module Gestion des Données

const now = Math.floor(Date.now() / 1000);
const INTERVALO_HORAS = 3600;
const TOTAL_PONTOS = 48;
const INDICES_ANOMALIA = [8, 15, 22, 31, 38];

const genererPoints = (capteur, decalage = 0) =>
    Array.from({ length: TOTAL_PONTOS }, (_, i) => {
        const isAnomalie = INDICES_ANOMALIA.includes(i);
        const base = 22 + decalage + Math.sin(i * 0.25) * 4 + Math.cos(i * 0.1) * 1.5;
        const bruit = (Math.random() - 0.5) * 0.4;
        return {
            id: i + 1,
            timestamp: now - (TOTAL_PONTOS - 1 - i) * INTERVALO_HORAS,
            date: new Date((now - (TOTAL_PONTOS - 1 - i) * INTERVALO_HORAS) * 1000),
            capteur,
            unite: '°C',
            valeur_brute: isAnomalie
                ? +(base + 14 + Math.random() * 3).toFixed(2)
                : +(base + bruit).toFixed(2),
            valeur_corrigee: +(base + bruit * 0.3).toFixed(2),
            anomalie: isAnomalie,
            statut: isAnomalie ? 'erreur' : 'ok',
            commentaire: isAnomalie ? 'Valeur aberrante détectée' : '',
        };
    });

export const mockDonneesByCapteur = {
    TMP_01: genererPoints('TMP_01', 0),
    TMP_02: genererPoints('TMP_02', -5),
    HUM_01: genererPoints('HUM_01', 30),
};

export const mockCapteurs = [
    { id: 'TMP_01', label: 'Température intérieure — TMP_01', unite: '°C' },
    { id: 'TMP_02', label: 'Température extérieure — TMP_02', unite: '°C' },
    { id: 'HUM_01', label: 'Humidité relative — HUM_01', unite: '%' },
];

export const mockImportPreview = [
    { timestamp: '2024-01-15 08:00', capteur: 'EXT_01', valeur: 18.4, unite: '°C' },
    { timestamp: '2024-01-15 09:00', capteur: 'EXT_01', valeur: 19.1, unite: '°C' },
    { timestamp: '2024-01-15 10:00', capteur: 'EXT_01', valeur: 21.3, unite: '°C' },
    { timestamp: '2024-01-15 11:00', capteur: 'EXT_01', valeur: 22.7, unite: '°C' },
    { timestamp: '2024-01-15 12:00', capteur: 'EXT_01', valeur: 24.0, unite: '°C' },
];
